import { render, staticRenderFns } from "./AdminRelatedSkills.vue?vue&type=template&id=585efc3c"
import script from "./AdminRelatedSkills.vue?vue&type=script&lang=js"
export * from "./AdminRelatedSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports